// Badges report after React commits the visible warning. Sharing the reporter by
// socket keeps multiple badges from counting the same incident more than once.
const warningReporters = new WeakMap();

export const reportConnectionWarningDisplayed = (socket) => {
    warningReporters.get(socket)?.();
};

// One tracker per socket, independent of how many NoSignal badges are rendered.
// Retries update the recovery summary instead of sending more billable events.
export const trackConnectionIncidents = (socket, posthog, colla, serverEndpoint) => {
    let incident = null;
    const capture = (event, properties) => posthog?.capture(event, {
        colla,
        server_endpoint: serverEndpoint,
        ...properties,
    });
    const onError = (error) => {
        const message = error?.message || 'Unknown connection error';
        if (incident) {
            incident.attempts += 1;
            incident.last_error = message;
            return;
        }
        incident = { started: Date.now(), attempts: 1, first_error: message, last_error: message };
        capture('socket_connection_error', { error_message: message });
        // "xhr poll error" means a transport failure, not necessarily a TLS error.
        if (/cert|certificate|ssl/i.test(message)) {
            capture('ssl_certificate_error', { error_message: message });
        }
    };
    const onConnect = () => {
        if (!incident) return;
        const completed = incident;
        incident = null;
        if (!completed.warningDisplayed) return;
        capture('signal_restored', {
            attempts: completed.attempts,
            duration_ms: Math.max(0, Date.now() - completed.started),
            first_error: completed.first_error,
            last_error: completed.last_error,
        });
    };
    const reportWarning = () => {
        if (!incident || incident.warningDisplayed) return;
        incident.warningDisplayed = true;
        capture('no_signal_displayed', { error: incident.first_error });
    };
    warningReporters.set(socket, reportWarning);
    socket.on('connect_error', onError);
    socket.on('connect', onConnect);
    return () => {
        if (warningReporters.get(socket) === reportWarning) warningReporters.delete(socket);
        socket.off('connect_error', onError);
        socket.off('connect', onConnect);
    };
};
